import { z } from 'zod';
import { User } from '../commentLikeApi/commentLikeApi.types';

// 子コメントいいねリクエスト型
export interface ChildCommentLikeRequest {
  child_comment_id: number | string;
}

// 子コメントいいね作成レスポンス
export const ChildCommentLikeResponseSchema = z.object({
  message: z.string(),
  childCommentLike: z.object({
    child_comment_id: z.string().or(z.number()),
    user_id: z.string(),
    created_at: z.string()
  })
});
export type ChildCommentLikeResponse = z.infer<typeof ChildCommentLikeResponseSchema>;

// 子コメントいいね削除レスポンス
export const ChildCommentUnlikeResponseSchema = z.object({
  message: z.string()
});
export type ChildCommentUnlikeResponse = z.infer<typeof ChildCommentUnlikeResponseSchema>;

// 子コメントいいね数レスポンス
export const ChildCommentLikesCountResponseSchema = z.object({
  child_comment_id: z.string().or(z.number()),
  likesCount: z.number()
});
export type ChildCommentLikesCountResponse = z.infer<typeof ChildCommentLikesCountResponseSchema>;

// 子コメントいいねしたユーザー情報
export const ChildCommentLikerSchema = z.object({
  id: z.string().or(z.number()),
  name: z.string(),
  icon_path: z.string().nullable()
});
export type ChildCommentLiker = z.infer<typeof ChildCommentLikerSchema>;

// 子コメントいいねユーザー一覧レスポンス
export const ChildCommentLikersResponseSchema = z.object({
  child_comment_id: z.string().or(z.number()),
  likers: z.array(ChildCommentLikerSchema)
});
export type ChildCommentLikersResponse = z.infer<typeof ChildCommentLikersResponseSchema>;

// 子コメントいいね状態レスポンス
export const ChildCommentLikeStatusResponseSchema = z.object({
  liked: z.boolean()
});
export type ChildCommentLikeStatusResponse = z.infer<typeof ChildCommentLikeStatusResponseSchema>; 